import React from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import { useAppDispatch } from 'store';
import { setUserToken } from 'store/slices/userSlicer';

type Props = {
  children?: React.ReactNode;
};

const KeycloakProvider: React.FC<Props> = ({ children }) => {
  const keycloakConfig = {
    url: 'https://auth.gridbit.live/',
    realm: 'master',
    clientId: 'eim_portal',
  };

  const keycloak = new Keycloak(keycloakConfig);

  const initConfig = {
    onLoad: 'check-sso', // Don't prompt for login automatically
    checkLoginIframe: false,
  };
  
  const dispatch = useAppDispatch();

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={initConfig}
      onTokens={(tokens) => {
        if (tokens.token) dispatch(setUserToken(tokens.token));
      }}
    >
      {children}
    </ReactKeycloakProvider>
  );
};

export default KeycloakProvider;
